import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logPageView } from '../../utils/googleAnalytics/google-analytics';

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      logPageView(location.pathname + location.search);
    }
  }, [location]);

  return null;
};

export default AnalyticsTracker;
